import { BaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';

export interface VerticalTabsItemUniDriver extends BaseUniDriver {
  getText: () => Promise<string>;
  pressEnterKey: () => Promise<void>;
}
